{
	"type": "line",
	"minzoom": 7,
	"layout": {
		"line-cap": "round",
		"line-sort-key": [
			"match",
			["get", "deceleration_type"],
			"Maximum",
			3,
			"Comfortable",
			2,
			"None",
			1,
			0
		]
	},
	"paint": {
		"line-color": [
			"match",
			["get", "deceleration_type"],
			"Maximum",
			"#2CAAF5",
			"Comfortable",
			"#84EDF2",
			"None",
			"#D9BFE8",
			"#ddd"
		],
		"line-offset": [
			"interpolate",
			["linear"],
			["zoom"],
			0,
			0,
			9,
			0,
			18,
			["match", ["get", "visual_offset"], "Right", 7, "Left", -7, 0]
		],
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 1, 18, 6],
		"line-opacity": ["step", ["zoom"], ["case", ["get", "all_zoom_levels"], 1, 0], 11, 1]
	}
}
